// jQuery will be available via <script>
/* global $ */
import { BASE_API_URL } from '../../base/endpoints'

$(document).ready(function () {
  // Token Form validation
  $('#license-manager-token-form').validate({
    errorClass: 'invalid',
    errorElement: 'div',
    rules: {
      'license-email': {
        required: true,
        email: true,
      },
    },
    // Removing error messages, to avoid duplication with the placeholders
    messages: {
      'license-email': {
        required: '',
        // unless you enter an invalid adress, where we show an error
        email: '',
      },
    },
    // Eager validation
    onfocusout: function (element) {
      this.element(element)
    },
    submitHandler: function () {
      $('#submit').addClass('is-waiting')
      $('#license-email').attr('disabled', 'disabled')

      // Submit the data via AJAX to the API
      var formData = {
        email: $('#license-email').val(),
      }

      // console.log("This is what I'm sending", formData);

      $.ajax({
        type: 'POST',
        url: `${BASE_API_URL}licensemanager/token/`,
        data: formData,
        dataType: 'json',
        encode: true,
      })
        .done(function (response) {
          // console.log("This is response.data", response.data);
          // console.log("This is response", response);

          // If we can't find your key
          if (response.data.matches == 0) {
            // Hide the form
            $('#license-manager-token-form').hide()

            // Store initial form messages into variables to retrieve on Retry (bullet proofing copy editing)
            var initialMessageHeading = $('.main-content h1.title').html()
            var initialMessageParagraph = $('.main-content p.description').html()

            // Display Error message
            $('.main-content-wrapper h1.title').text('License not found')
            $('.main-content-wrapper p.description').text(
              'We couldn’t find a license associated with that email address. Please make sure you have entered your details correctly.'
            )
            // Contact Customer Support call to action
            $('.main-content-wrapper').append(
              '<p class="description main-content__description styled-text">Depending on which version of Sketch you’re using, you can check the email address attached to your license by opening the app and clicking on <code>Sketch > Preferences</code> and then clicking on ”Account” or via <code>Sketch > About & Registration</code> in the menu bar.</p>'
            )
            // Retry button
            $('.main-content-wrapper').append(
              '<p class="actions-wrapper"><button class="button full revert">Try Again</button>'
            )
            $('.revert').on('click', function () {
              // Restore header
              $('.main-content-wrapper h1.title').html(initialMessageHeading)
              // Remove inserted <p>s except the first one
              $('.main-content-wrapper p.description ~ p').remove()
              // Restore the first <p> message
              $('.main-content-wrapper p.description').html(initialMessageParagraph)
              // Reset email
              $('.main-content-wrapper #license-email').val('')
              // Re-enable form for submit again
              $('#submit').removeClass('is-waiting')
              $('#license-email').removeAttr('disabled')
              // Display the form again
              $('#license-manager-token-form').show()
              $('.two-column-layout').removeClass('error')
            })
            $('.two-column-layout').addClass('error')
          } else if (response.data.matches == 1) {
            // If we find your key & email
            // Everything worked fine, hide form and show message
            $('#submit').removeClass('is-waiting').addClass('is-successful')
            $('.button__label').css('visibility', 'hidden')
            $('.two-column-layout').addClass('success')
            // Remove previous message (if any)
            $('.submit').children('small').remove()
            $('.submit').append(
              '<small class="styled-text">We’ve sent an email to <strong>' +
                formData.email +
                '</strong> with your access code.</small>'
            )
          }

          // console.log("This is response status", response.status);
          // If you entered an invalid email
          if (response.status == 0) {
            $('#submit').removeClass('is-waiting').addClass('error')
            // Remove previous message (if any)
            $('.submit').children('small').remove()
            $('.submit').append('<small>Your email address is not valid. Please try again.</small>')
            setTimeout(function () {
              $('#submit').removeClass('is-waiting error')
              $('#license-email').removeAttr('disabled')
              $('.submit').children('small').remove()
            }, 3000)
          }
        })
        .fail(function (request, textStatus, errorThrown) {
          $('#submit').removeClass('is-waiting').addClass('error')
          setTimeout(function () {
            $('#submit').removeClass('is-waiting error')
            $('#license-email').removeAttr('disabled')
          }, 3000)
          // Remove previous message (if any)
          $('.submit').children('small').remove()
          $('.submit').append('<small>An error occurred. Please try again.</small>')
          console.log('textStatus: ', textStatus, 'errorThrown: ', errorThrown)
        })
    },
  })
})
